import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=2b551676&"
import script from "./Mapa.vue?vue&type=script&lang=js&"
export * from "./Mapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports